import {THEMES} from 'modules/theme/constants';
import {IThemeState} from 'modules/theme/types';
import {createContext} from 'react';

export interface IThemeContextProps extends IThemeState {}

export const ThemeContext = createContext<IThemeContextProps>({
    theme: THEMES.light,
});
